<template>
  <div class="container-fluid">
    <div class="col-sm-6 col-md-6" id="secret-div">
      <v-alert
        :value="checkSecret"
        color="red"
        icon="warning"
        style="padding: 2px; margin-bottom: 4%"
      >
        Secret Key is not correct
      </v-alert>
      <v-alert :value="validat" color="red" icon="warning" style="padding: 2px; margin-bottom: 4%">
        Secret Key is required
      </v-alert>
      <v-alert :value="validat2" color="red" icon="warning" style="padding: 2px; margin-bottom: 4%">
        Secret Key is required <br />
        Confirm Secret Key is required
      </v-alert>
      <v-alert :value="validat3" color="red" icon="warning" style="padding: 2px; margin-bottom: 4%">
        Confirm Secret Key is not match
      </v-alert>
      <v-alert :value="validat4" color="red" icon="warning" style="padding: 2px; margin-bottom: 4%">
        You already have secret key
      </v-alert>
      <h4 style="color: black">Hi {{ loggedInUserData.full_name }}</h4>
      <img
        v-if="loggedInUserData.profile_image == null"
        src="../../assets/images/Profile_avatar.png"
        class="img-circle"
        style="height: 60px; width: 60px"
        alt=""
      />
      <img
        v-else
        :src="'/images/' + loggedInUserData.profile_image"
        class="img-circle"
        style="height: 60px; width: 60px"
        alt=""
      />
      <span style="color: black">{{ loggedInUserData.email }}</span>
      <v-alert value="true" outline color="pink" icon="info" style="padding: 2px; margin-top: 4%">
        To see this section you have to enter your Secret Key
      </v-alert>

      <form @submit.prevent="submitForm1()">
        <v-flex xs10 sm10 md12>
          <v-text-field
            color="green"
            label="Secret key"
            :append-icon="e1 ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (e1 = !e1)"
            :type="e1 ? 'password' : 'text'"
            v-model="secretKeyData.secret_key"
          ></v-text-field>
        </v-flex>

        <div class="col-sm-12 col-md-6 text-left" style="padding-top: 20px">
          <a @click="showSecondForm()">Don't have Secret Key?</a>
        </div>

        <div class="col-sm-12 col-md-6 text-right">
          <v-btn
            type="submit "
            style="height:auto; padding-left: 0px; padding-right: 0px"
            outline
            color="success"
            >Let me in</v-btn
          >
        </div>
      </form>

      <form id="second-form" style="display: none" @submit.prevent="submitForm2()">
        <v-flex xs10 sm10 md12>
          <v-text-field
            label="Secret key"
            :append-icon="e2 ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (e2 = !e2)"
            :type="e2 ? 'password' : 'text'"
            v-model="addSecretKeyData.secret_key"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs10 sm10 md12>
          <v-text-field
            label="Confirm Secret key"
            :append-icon="e3 ? 'visibility' : 'visibility_off'"
            :append-icon-cb="() => (e3 = !e3)"
            :type="e3 ? 'password' : 'text'"
            v-model="addSecretKeyData.confirm_secret_key"
          >
          </v-text-field>
        </v-flex>

        <div class="col-sm-12 col-md-12 text-right">
          <v-btn
            type="submit "
            style="height:auto; padding-left: 0px; padding-right: 0px;"
            outline
            color="primary"
            >Create</v-btn
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  mounted() {
    this.getLoggedInUser()
    if (localStorage.getItem('secret_key') === 'true') {
      let component = window.location.search.replace('?component=', '')
      this.$router.push('/' + component)
    }
  },

  watch: {
    $route() {
      if (localStorage.getItem('secret_key') === 'true') {
        let component = window.location.search.replace('?component=', '')
        this.$router.push('/' + component)
      }
    }
  },

  data() {
    return {
      x: 1,
      checkSecretUrl: 'api/check_secret',
      addSecretUrl: 'api/add_secret',
      loggedInUserData: [],
      theComponent: '',
      secretKeyData: {
        secret_key: ''
      },
      addSecretKeyData: {
        secret_key: '',
        confirm_secret_key: ''
      },
      checkSecret: false,
      validat: false,
      validat2: false,
      validat3: false,
      validat4: false,
      e1: true,
      e2: true,
      e3: true
    }
  },

  methods: {
    showSecondForm() {
      if (this.x === 1) {
        this.x = 2
        $('#second-form').show()
      } else if (this.x === 2) {
        this.x = 1
        $('#second-form').hide()
      }
    },

    submitForm1() {
      this.theComponent = window.location.search.replace('?component=', '')
      if (this.secretKeyData.secret_key === '') {
        this.validat = true
        let a = this
        setTimeout(function() {
          a.validat = false
        }, 2000)
      } else {
        this.validat = false
        let token = localStorage.getItem('access_token')

        axios
          .post(this.checkSecretUrl + '/' + this.loggedInUserData.user_id, this.secretKeyData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            this.checkSecret = false
            localStorage.setItem('secret_key', true)
            localStorage.setItem('secret_duration', 15)
            this.$router.push('/' + this.theComponent)
          })
          .catch(() => {
            this.checkSecret = true
            let a = this
            setTimeout(function() {
              a.checkSecret = false
            }, 1500)
          })
      }
    },

    submitForm2() {
      this.theComponent = window.location.search.replace('?component=', '')
      if (
        this.addSecretKeyData.secret_key === '' ||
        this.addSecretKeyData.confirm_secret_key === ''
      ) {
        this.validat2 = true
        let a = this
        setTimeout(function() {
          a.validat2 = false
        }, 4000)
      } else if (this.addSecretKeyData.secret_key !== this.addSecretKeyData.confirm_secret_key) {
        this.validat3 = true
        let a = this
        setTimeout(function() {
          a.validat3 = false
        }, 2000)
      } else {
        this.validat3 = false
        let token = localStorage.getItem('access_token')

        axios
          .post(this.addSecretUrl, this.addSecretKeyData, {
            headers: { Authorization: 'Bearer ' + token }
          })
          .then(response => {
            localStorage.setItem('secret_key', true)
            localStorage.setItem('secret_duration', 15)
            this.$router.push('/' + this.theComponent)
          })
          .catch(error => {
            if (error.response.data.code_status === 422) {
              this.validat4 = true
              let b = this
              setTimeout(function() {
                b.validat4 = false
              }, 3000)
            }
          })
      }
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style scoped>
#secret-div {
  border-style: solid;
  border-width: 1px;
  box-shadow: 1px 1px 10px 2px;
  color: #cccccc;
  border-radius: 10px;
  padding: 10px;
  margin-left: 25%;
  margin-top: 10%;
  margin-bottom: 10%;
}
</style>



// WEBPACK FOOTER //
// src/components/secret.vue